import _ from 'lodash';
import objectAssign from 'object-assign';
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../../actions/clubActions';
import * as memberActions from '../../actions/memberActions';
import { Link } from 'react-router';
import MemberList from './MemberList';
import HeaderImage from '../../components/common/HeaderImage';
import * as utils from '../../components/common/utils';
import Loading from '../../components/Loading';
import Button from '../../components/common/Button';
import PermissionLink from '../../components/common/PermissionLink';

class ViewClub extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.componentWillReceiveProps = this.componentWillReceiveProps.bind(this);
    this.shouldUpdateClubDetails = this.shouldUpdateClubDetails.bind(this);
    this.deleteClub = this.deleteClub.bind(this);
    this.deleteMember = this.deleteMember.bind(this);
    let clubDetails = objectAssign({}, props.clubDetails);
    this.state = {
      clubDetails: clubDetails,
    };
  }

  componentWillReceiveProps(nextProps) {
    if(this.shouldUpdateClubDetails(nextProps)) {
      this.setState({clubDetails: nextProps.clubDetails});
    }
  }

  shouldUpdateClubDetails(nextProps) {
    let p = this.props;
    let updated = p.clubDetailsUpdated !== nextProps.clubDetailsUpdated;
    return _.every([updated], (item) => item === true);
  }

  deleteClub(e) {
    if (!confirm('Bekreft at du ønsker å slette denne klubben')) {
      e.preventDefault();
      return false;
    }
    this.props.actions.deleteClub(this.props.clubId);
  }

  deleteMember(e, id) {
    if (!confirm('Bekreft at du ønsker å slette dette medlemmet')) {
      e.preventDefault();
      return false;
    }
    this.props.memberActions.deleteMember(id);
  }

  render() {
    let details = this.state.clubDetails;
    let address = utils.join([details.club_address, details.club_zip,
      details.club_municipality, details.club_county, details.club_country], ", ");

    return (
      <div>
        <div className="club-page-container container">
          <div className="row">
            <div className="col-md-4 col-lg-4">
              <HeaderImage
                headerLink={details.image_thumbnail}/>
            </div>
            <div className="col-md-8 col-lg-8">
              <h1 className="club-page-title">
                {details.name}
                <Loading loading={this.props.loadingClubs} />
              </h1>
              <div className="club-address">
                <strong>{'Adresse: '}</strong>
                {address}
              </div>
              <div className="contact-person">
                <strong>{'Kontaktperson: '}</strong>
                {details.club_contact_person}
                <strong>{' Epost: '}</strong>
                {details.club_contact_email}
                <strong>{' Tlf: '}</strong>
                {details.club_contact_phone_number}
              </div>
            </div>

          </div>
          <hr/>
          <div className="row">
            <div className="col-md-12">
              <Link className="btn btn-default"
                to={'/klubber'}>
                Tilbake
              </Link>
              <span className="pull-right">
                <Button
                  permission={details.permissions.destroy}
                  className="btn btn-danger"
                  faName={'trash'}
                  onClick={this.deleteClub}>
                  {' Slett'}
                </Button>
                {' '}
                <PermissionLink
                  permission={details.permissions.write}
                  to={'/klubb/'+ details.id +'/rediger'}
                  className="btn btn-default"
                  faName="edit">
                  <span className="hidden-xs">{' Rediger'}</span>
                </PermissionLink>
              </span>
            </div>
          </div>
        </div>
        <MemberList clubId={this.props.clubId} />
      </div>
    );
  }
}

ViewClub.propTypes = {
  actions: PropTypes.object.isRequired,
  memberActions: PropTypes.object.isRequired,
  clubDetails: PropTypes.object.isRequired,
  memberList: PropTypes.array.isRequired,
  clubDetailsUpdated: PropTypes.number,
  memberListUpdated: PropTypes.number,
  clubId: PropTypes.string.isRequired,
  loadingClubs: PropTypes.bool,
  loadingMembers: PropTypes.bool,
};

function mapStateToProps(state, ownProps) {
  return {
    clubId: ownProps.params.clubId,
    loadingClubs: state.clubs.loadingClubs,
    loadingMembers: state.clubs.loadingMembers,
    clubDetails: state.clubs.clubDetails,
    memberList: state.clubs.memberList,
    clubDetailsUpdated: state.clubs.clubDetailsUpdated,
    memberListUpdated: state.clubs.memberListUpdated,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
    memberActions: bindActionCreators(memberActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewClub);



/** WEBPACK FOOTER **
 ** ./src/containers/clubs/ViewClub.js
 **/